"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlagsStatus = void 0;
const use_flags_context_hook_1 = require("./use-flags-context.hook");
const useFlagsStatus = () => {
    const { flagsReady, flagsError } = (0, use_flags_context_hook_1.useFlagsContext)();
    return { flagsReady, flagsError };
};
exports.useFlagsStatus = useFlagsStatus;
//# sourceMappingURL=use-flags-status.hook.js.map